import { memo } from 'react';
import type { IconProps } from './types';

const CloudDownloadIcon = ({
    iconLabel,
    color,
    small,
}: IconProps & { small?: boolean }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={small ? '18' : '24'}
        height={small ? '18' : '24'}
        viewBox="0 0 24 24"
        fill="none"
        data-icon={iconLabel}
        color={color}
    >
        <g clipPath="url(#clip0_10396_25950)">
            <path
                d="M19.3825 6.79264C18.5719 2.72551 14.6177 0.0856802 10.5506 0.896287C7.57584 1.48918 5.24985 3.8137 4.65512 6.78807C1.7714 7.1204 -0.297142 9.72746 0.0350106 12.6114C0.340796 15.2655 2.58878 17.2679 5.26047 17.2661H9.01486C9.42959 17.2661 9.76578 16.9299 9.76578 16.5152C9.76578 16.1004 9.42959 15.7643 9.01486 15.7643H5.26047C3.1868 15.752 1.51597 14.0612 1.52805 11.9877C1.54032 9.91404 3.23111 8.24302 5.30478 8.25529C5.68747 8.25529 6.009 7.96745 6.05112 7.58696C6.43234 4.29143 9.41311 1.92882 12.7088 2.31004C15.4796 2.63048 17.6653 4.81621 17.9857 7.58696C18.0487 7.97422 18.3842 8.25785 18.7764 8.25529C20.8501 8.25529 22.531 9.9362 22.531 12.0099C22.531 14.0833 20.8501 15.7643 18.7764 15.7643H15.022C14.6073 15.7643 14.2711 16.1004 14.2711 16.5152C14.2711 16.9299 14.6073 17.2661 15.022 17.2661H18.7766C21.6793 17.248 24.018 14.88 24 11.9773C23.9835 9.33378 22.0064 7.11381 19.3825 6.79264Z"
                fill="currentColor"
            />
            <path
                d="M14.6721 18.8052L12.7685 20.7093V11.2587C12.7685 10.844 12.4323 10.5078 12.0178 10.5078C11.6031 10.5078 11.2669 10.844 11.2669 11.2587V20.7093L9.36332 18.8052C9.07529 18.5068 8.59977 18.4985 8.30149 18.7867C8.00321 19.0748 7.99497 19.5501 8.283 19.8484C8.28922 19.8548 8.29526 19.8608 8.30149 19.8669L11.4861 23.0522C11.5556 23.1216 11.638 23.1767 11.7287 23.2144C11.9134 23.2926 12.122 23.2926 12.3069 23.2144C12.3976 23.1767 12.48 23.1216 12.5494 23.0522L15.7339 19.8669C16.0322 19.5788 16.0404 19.1035 15.7524 18.8052C15.4642 18.507 14.9889 18.4987 14.6906 18.7867C14.6844 18.7928 14.6781 18.7988 14.6721 18.8052Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_10396_25950">
                <rect width="24" height="24" fill="currentColor" />
            </clipPath>
        </defs>
    </svg>
);

export default memo(CloudDownloadIcon);
